const searchResultsStyles = theme => ({
  collectionRowHead: {
    ...theme.mixins.gridColumns(theme.spacing(2)),
    alignItems: 'center',
    justifyContent: 'space-between',
    userSelect: 'none',
    cursor: 'pointer',
  },
  collectionRowTitle: {
    position: 'relative',
  },
  showBorder: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.border.dark,
    transition: theme.globals.transition,
  },
  hideBorder: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: 'transparent',
    transition: theme.globals.transition,
  },
  tabs: {
    boxShadow: theme.globals.boxShadowSmaller,
    zIndex: theme.zIndex.secondary,
  },
})

export default searchResultsStyles
